import { render, staticRenderFns } from "./userschong.vue?vue&type=template&id=21302efa&scoped=true"
import script from "./userschong.vue?vue&type=script&lang=js"
export * from "./userschong.vue?vue&type=script&lang=js"
import style0 from "./userschong.vue?vue&type=style&index=0&id=21302efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21302efa",
  null
  
)

export default component.exports